import React from 'react';
import BulkAction from '../../../../../../shared/design-system/components/atoms/bulk-action';
import Button from '../../../../../../shared/design-system/components/atoms/button';
import { Permissions } from '../../../../../../shared/utils/access-control/enums/permissions';
import hasPermission from '../../../../../../shared/utils/access-control/has-permission';

const BulkActions = ({
  viewAddToSequenceModal,
  viewDeleteProspectModal,
  unsubscribeProspect,
  viewEmailVerificationModal,
  renderTagIcon = null,
}) => {
  const data = [
    hasPermission(Permissions.PROSPECT_UPDATE) && {
      renderComponent: 'IconButton',
      actionConfiguration: {
        icon: 'send',
        onClick: viewAddToSequenceModal,
        variant: Button.Variant.Default,
        theme: Button.Theme.Ghost,
      },
      popoverText: 'Add to Sequence',
      shouldShowPopover: true,
    },

    hasPermission(Permissions.PROSPECT_UPDATE) && {
      renderComponent: 'Custom',
      actionConfiguration: {
        component: renderTagIcon(),
      },
    },

    hasPermission(Permissions.PROSPECT_UPDATE) && {
      renderComponent: 'IconButton',
      actionConfiguration: {
        icon: 'shield-check',
        onClick: viewEmailVerificationModal,
        variant: Button.Variant.Default,
        theme: Button.Theme.Ghost,
      },
      popoverText: 'Verify Email(s)',
      shouldShowPopover: true,
    },
    hasPermission(Permissions.PROSPECT_READ) && {
      renderComponent: 'IconButton',
      actionConfiguration: {
        icon: 'unavailable',
        onClick: unsubscribeProspect,
        variant: Button.Variant.Default,
        theme: Button.Theme.Ghost,
      },
      popoverText: 'Unsubscribe',
      shouldShowPopover: true,
    },
    hasPermission(Permissions.PROSPECT_DELETE) && {
      renderComponent: 'IconButton',
      actionConfiguration: {
        icon: 'trash',
        onClick: viewDeleteProspectModal,
        variant: Button.Variant.Default,
        theme: Button.Theme.Ghost,
      },
      popoverText: 'Delete',
      shouldShowPopover: true,
    },
  ];

  return (
    <>
      <BulkAction data={data} />
    </>
  );
};

export default BulkActions;
